import React from 'react';
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {useTranslation} from "react-i18next";
import {GB, HU, RO} from 'country-flag-icons/react/3x2';

const flags = {hu: <HU width={20}/>, en: <GB width={20}/>, ro: <RO width={20}/>};

function LanguageSelector(props) {
    const {i18n} = useTranslation();

    const [anchorElLang, setAnchorElLang] = React.useState(null);
    const [lang, setLang] = React.useState(i18n.language);

    const handleOpenLangMenu = (event) => {
        setAnchorElLang(event.currentTarget);
    };

    const langChange = (code) => {
        setLang(code);
        i18n.changeLanguage(code);
        handleCloseLangMenu();
    };

    const handleCloseLangMenu = () => {
        setAnchorElLang(null);
    };
    return (<>
            <IconButton
                size="large"
                aria-label="Language selector"
                aria-controls="lang-appbar"
                aria-haspopup="true"
                onClick={handleOpenLangMenu}
                color="inherit"
            >
                {flags[lang]}
            </IconButton>
            <Menu
                id="lang-appbar"
                anchorEl={anchorElLang}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={Boolean(anchorElLang)}
                onClose={handleCloseLangMenu}
                sx={{display: {xs: 'block', md: 'block'}}}
            >
                {Object.keys(flags).filter(code => code !== lang).map((code) => (
                    <MenuItem key={code} onClick={() => langChange(code)}>
                        {flags[code]}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}

export default LanguageSelector;
